import React, { Component } from 'react';
import { Card, Button } from 'react-bootstrap'

class resultPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      "data": {}
    };
  }

  render() {

    let summary = localStorage.getItem('summary')
    console.log('dekho',summary);

    let imgUrl = {
      green: "https://da-img.s3.amazonaws.com/corona_low_risk.svg",
      amber: "https://da-img.s3.amazonaws.com/corona_medium_risk.svg",
      quarantine: "https://da-img.s3.amazonaws.com/corona_quarantine.svg",
      redflag: "https://da-img.s3.amazonaws.com/corona_high_risk.svg"
    }
    
    let language = localStorage.getItem('language');

    let tempData = {
      english: {
        docsAppText1: {
          green: "Based on your assessment, you are at a lower risk of infection.",
          amber: "Based on your assessment, DocsApp recommends the following actions:",
          quarantine: "Based on your assessment, you may have been exposed to the virus & you might develop the illness.",
          redflag: "Based on your assessment, DocsApp recommends the following actions:"
        },
        docsAppText2: {
          green: "DocsApp recommends general precautions to avoid catching the infection",
          amber: "",
          quarantine: "However, it is important to remember that most people who are exposed to the coronavirus do not experience symptoms of the COVID-19 illness, and most people who experience minor symptoms may not face serious issues.",
          redflag: ""
        },
        docsAppText3: {
          green: "",
          amber: "",
          quarantine: "DocsApp recommends these precautions to avoid spreading the infection:",
          redflag: ""
        },
        bodyText: {
          green: ["1. Wash your hands with soap and water regularly.", "2. Maintain physical distance.", "3. Reduce physical contact with people."],
          amber: ["1. Try to eat balanced & nutritious meals.", "2. Measure and record your body temperature if you feel feverish.", "3. Consult a doctor online for proper diagnosis to monitor & manage your symptoms.", "4. In the meantime, wash your hands regularly, follow social distancing, use a mask if you have a cough or if you’re sneezing.", "5. If you develop difficulty in breathing, pain or pressure in the chest, fainting, or if your lips turn blue, visit the nearest hospital immediately.", "6. Dial the national coronavirus helpline if necessary.", "7. If you do not have any of these symptoms, going to a hospital is not advised as it can worsen your condition and spread the infection further."],
          quarantine: ["1. Going to a hospital can increase the risk of infection.", "2. Consult a doctor on call or online and start home isolation immediately.", "3. Monitor your symptoms and get medical attention if your situation worsens.", "4. COVID 19 lab tests may be required at your physician’s advice.", "5. For immediate medical help you can also call the DocsApp helpline number."],
          redflag: ["1. If you have difficulty in breathing, chest pain or tightness in the chest, seek immediate medical attention and get yourself tested.", "2. You can meanwhile consult a doctor online on DocsApp to understand your symptoms & treatment options better.", "3. We also recommend calling 100, or the national or regional coronavirus helpline to report your exposure & travel history and symptoms."]
        },
        docsAppText4: "Remember!",
        docsAppText5: "For more info on coronavirus, its symptoms & prevention; you can always talk to a doctor on DocsApp",
        docsAppText6: "For a free consultation: ",
        docsAppText7: "Download"
      },
      hindi: {
        docsAppText1: {
          green: "आपके मूल्यांकन के अनुसार, आपको संक्रमण होने की कम संभावना है| फिर भी संक्रमण से बचाव के लिए आपको कुछ बातों का ध्यान रखना चाहिए :",
          amber: "आपके मूल्यांकन के अनुसार, DocsApp आपको कुछ ज़रूरी बातें बताना चाहता है: ",
          quarantine: "आपके मूल्यांकन के अनुसार, शायद आप वायरस की चपेट में हैं और आपको यह बिमारी हो सकती है | लेकिन ज़रूरी नहीं की ज़्यादातर लोग जो इस वायरस की चपेट में आये हैं, उनमें कोविड-19 के लक्षण नहीं देखे गए हैं | और जिन लोगों में लक्षण कम देखे गए हैं उन्हें यह बिमारी होने का खतरा कम है | ",
          redflag: "आपके मूल्यांकन के अनुसार, DocsApp आपको कुछ ज़रूरी बातें बताना चाहता है:"
        },
        docsAppText2: {
          green: "",
          amber: "",
          quarantine: "",
          redflag: ""
        },
        docsAppText3: {
          green: "",
          amber: "",
          quarantine: "फिर भी संक्रमण से बचाव के लिए आपको कुछ बातों का ध्यान रखना चाहिए :",
          redflag: ""
        },
        bodyText: {
          green: ["1. साबुन और पानी से बार बार हाथ धोएँ", "2. लोगों से दूरी बनाकर रखें ", "3. ज़्यादा भीड़ में न निकलें"],
          amber: ["1. पौष्टिक और सम्पूर्ण भोजन खाएँ |", "2. भुखार जैसा लगे तो अपना तापमान माप लें |", "3. डॉक्टर से फ़ोन या चैट यानी ऑनलाइन बात करें|", "4. साथ ही अपने हाथ धोते रहिए, लोगों से दूर रहें, यदि खांस या छींक रहे हैं तो मास्क पहने रखें |", "5. यदि आपको साँस लेने में तकलीफ, सीने में दर्द या जकड़न, चक्कर आ जाए या आपके होंठ नीले पड़ जाए तो तुरंत नज़दीकी अस्पताल जाएँ|", "6. ज़रूरत पड़े तो कोरोना वायरस की राष्ट्रिय हैल्पलाइन पर कॉल करें|", "7. यदि कोई भी लक्षण नहीं है तो अस्पताल जाने से बचें |"],
          quarantine: ["1. किसी अस्पताल जाना संक्रमण को बढ़ावा दे सकता है |", "2. डॉक्टर से ऑनलाइन बात कीजिए और कुछ दिन अकेले रहना शुरू कर दीजिए |", "3. अपने लक्षणों पर ध्यान दें और ज़रूरत पड़ने पर डॉक्टर से तुरंत बात करें |", "4. डॉक्टर के कहने के बाद ही कोविड-19 की जाँच करवाएँ|", "5. यदि तुरंत मदद चाहिए तो DocsApp के हैल्पलाइन नंबर पर कॉल भी कर सकते हैं |"],
          redflag: ["1. यदि आपको साँस लेने में तकलीफ, सीने में दर्द या जकड़न है तो तुरंत डॉक्टर से बात करें और अपनी जाँच करवाएँ|", "2. इस दौरान आप DocsApp पर भी डॉक्टर से बात कर सकते हैं |", "3. इसके साथ ही आपको 100 नंबर या अपने क्षेत्रीय कोरोना वायरस की हैल्पलाइन नंबर पर अपनी स्तिथि के बारे में ज़रूर खबर और तमाम जानकारी दें|"]
        },
        docsAppText4: "याद रखें !",
        docsAppText5: "कोरोना वायरस के लक्षण, बचाव और अधिक जानकारी के लिए आप DocsApp पर डॉक्टर से मुफ्त में बात कर सकते हैं |",
        docsAppText6: "मुफ्त परामर्श के लिए डाउनलोड कीजिए DocsApp",
        docsAppText7: "डाउनलोड"
      }
    }   
    let data = tempData[language];
    console.log(data);

    return (
      <div >
        <div >
          <img alt="piggy" src={imgUrl[summary]} style={{margin: 'auto', display: 'block', width: '210px', paddingTop:'20px'}}/>
          <Card border="success" style={{ width: '18rem', borderRadius: '20px', margin: "auto", marginTop: "10px"}}>
            <Card.Body>
              <Card.Title style={{fontWeight: 'bold', fontSize: '17px', textAlign: 'center'}}>{data.docsAppText1[summary]}</Card.Title>
              
              {data.docsAppText2[summary] ? <p style={{textAlign: 'center', fontSize: '13px'}}>{data.docsAppText2[summary]}</p> : ''}
              {data.docsAppText3[summary] ? <p style={{textAlign: 'center', fontSize: '13px', fontWeight: 'bold'}}>{data.docsAppText3[summary]}</p> : ''}
              
              {data.bodyText[summary].map((value, index) => {
                return <p style={{fontSize: '12px', fontWeight: '500', margin: '4px'}}>{value}</p>
              })} 
              
            </Card.Body>
          </Card>
          <br/>
          <Card border="success" style={{ width: '18rem', borderRadius: '20px', margin: "auto", marginBottom: "25px"}}>
            <Card.Body>
              <Card.Title style={{fontWeight: 'bold', fontSize: '17px', textAlign: 'center'}}>{data.docsAppText4}</Card.Title>
              <Card.Text>
                <p style={{fontSize: '12px', fontWeight: '500', margin: '4px', textAlign: 'center'}}>{data.docsAppText5}</p>
              </Card.Text>
              <Card.Title style={{fontWeight: 'bold', fontSize: '17px', textAlign: 'center'}}>{data.docsAppText6}</Card.Title>
              <Button variant="success" style={{textAlign: 'center', margin: 'auto', display: 'block', borderRadius: '25px', fontWeight:'bold'}} href="https://rb.docsapp.in/cCEJVbHkf5?channel=coronaLandingPage&feature='https://covid19.docsapp.in'&campaign='covid19chatbot'">{data.docsAppText7} DocsApp</Button>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default resultPage;
